<template>
  <div class='bg-gray-50'>
    <h2 class='px-4 py-3 text-xl'>Objectives</h2>
    <div class='divide-y border-t'>
      <button type='button' class='px-4 py-3 hover:bg-gray-100 w-full text-left text-sm' :class='isSelectedObjective(objective) ? "bg-gray-200 hover:bg-gray-200" : ""' v-for="objective in props.objectives" :key="objectiveCollection.getId(objective)" @click='selectResponse(objective)'>
        {{ objectiveCollection.getName(objective) }}
      </button>
    </div>
  </div>
</template>

<script setup>

import { computed, reactive } from 'vue';

import { getCollection } from '@/kernel/collections';
import { scoreMap } from '@/kernel/scoring';

import SearchInput from '@/components/inputs/search-input.vue';

const themeCollection = getCollection('theme');
const objectiveCollection = getCollection('objective');

const props = defineProps({
  state: Object,
  objectives: Array
});

const selectResponse = (objective) => {
  props.state.objective = objective;
  props.state.drawerOpen = false;
}

const isSelectedObjective = (objective) => {
  return objectiveCollection.getId(props.state.objective) === objectiveCollection.getId(objective);
}

</script>